<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import LabelPill from 'dashboard/components-next/label/LabelPill.vue';

const props = defineProps({
  label: {
    type: Object,
    default: null,
  },
  isHovered: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['remove', 'hover']);

const handleRemoveLabel = () => {
  emit('remove', props.label);
};

const handleMouseEnter = () => {
  emit('hover', props.label?.id);
};
</script>

<template>
  <div
    class="inline-flex max-w-full min-w-0 items-center gap-0.5"
    @mouseenter="handleMouseEnter"
  >
    <LabelPill :label="label" dense />
    <div
      class="relative flex w-0 shrink-0 overflow-hidden transition-[width] duration-300 ease-out ltr:left-0 rtl:right-0"
      :class="{ 'w-6': isHovered }"
    >
      <Button
        class="w-6 bg-transparent transition-opacity duration-200 !h-7 ltr:rounded-l-none ltr:rounded-r-md rtl:rounded-l-md rtl:rounded-r-none"
        :class="{ 'opacity-0': !isHovered, 'opacity-100': isHovered }"
        type="button"
        slate
        xs
        faded
        icon="i-lucide-x"
        @click="handleRemoveLabel"
      />
    </div>
  </div>
</template>
